'use client';

import { useTranslation } from 'next-i18next';

/**
 * @description Offer Page Title
 */
export const OfferPageTitle = () => {
  const { t } = useTranslation('common');

  return (
    <>
      <h1 className="relative mt-10 text-center text-4xl font-bold">{t('offer.page.heading.title')}</h1>
      <h2 className="relative mt-5 mb-10 text-center text-2xl font-semibold">{t('offer.page.heading.subtitle')}</h2>
    </>
  );
};
